import React from 'react';
import './ActionRow.css';

export default function ActionRow({ onReset, onUlozPdf }) {
  return (
    <div className="action-row">
      <button type="button" className="action-btn" onClick={onReset}>
        RESET
      </button>

      <button type="button" className="action-btn action-btn--primary" onClick={onUlozPdf}>
        ULOŽ PONUKU (PDF)
      </button>
    </div>
  );
}